// Dashboard landing page — delegates to the shared DashboardHome
// component, which renders the four-zone layout for both desktop and
// mobile. The V4 mobile shell historically got its own DashboardMobile
// variant for density tuning; DashboardHome auto-stacks via CSS so
// the two code paths now share a single implementation.

import React from "react";
import DashboardHome from "../components/DashboardHome";
import DashboardMobile from "./DashboardMobile";
import { useVersion } from "../components/Version";

export default function Dashboard(props) {
  const { version } = useVersion();
  if (version === "v4") return <DashboardMobile {...props}/>;
  return <DashboardHome {...props}/>;
}
